import './App.css';
import pro_pic from './img/pro_pic_city_museum.jpg';
import React, { Component } from "react";
import ReactRoundedImage from "react-rounded-image";
import Divider from '@material-ui/core/Divider';

function AboutMe() {
  return (
    <div className="wrapper">
        <img src={pro_pic} alt="profile pic" className="profile_pic" />
        <p className="content_page">
        I am a second-year PhD student studying computer science at Carnegie Mellon University. I am
        advised by <a href="https://www.andrew.cmu.edu/user/liminjia/" target="_blank" rel="noreferrer">Limin Jia</a>.
        
        <br /><br />

        In Spring 2021, I completed my undergraduate at the University of Kansas where I 
        double-majored in computer science and mathematics, and minored in visual arts (emphasis 
        in painting). While there, I was a research assistant under the guidance of Dr. 
        Suzanne Shontz in scientific computing. <br /><br />

        I am broadly interested in solving problems at the interface of mathematics and 
        computer science. Some of my favorite things include <b>programming language design</b>, <b>verification</b>, <b>intermittent computing</b>, <b>parametricity</b>, <b>quantitative analysis</b>, <b>oil painting</b>, and <b>artichoke pizza</b>. 
        
        <br /><br />
        
        <Divider />
        <br />
        Email: mdotzel [at] andrew [dot] cmu [dot] edu
        <br />
        Office: GHC 9223
        </p>
      
    </div>
  );
}

export default AboutMe;